module.exports = __webpack_public_path__ + "img/ios1icon10.57a7c59a.png";